module.exports = __webpack_public_path__ + "img/gray.ddcb0736.svg";